import React from 'react';
import { CargoTemperatureConfig } from '../../../../types/ViewModel/CargoTempLog/CargoTemperatureConfig';
import { InputFieldsRow, InputFieldsWrapper } from '../CargoTempConfig.style';
import { Wrapper } from './CargoInputFieldsComponent.style';
import OdfjellInputComponent, { InputChangeData } from '../../../common/odfjell-input-component/OdfjellInputComponent';
import { useCargoTempLogStore } from '../../../../context/CargoTempLogContext';
import { CargoTemperatureInputField } from '../../../../types/ViewModel/CargoTempLog/CargoTemperatureInputField';
import useReadOnlyUtils from 'src/utils/useReadOnlyUtils';
type Props = {
    keyName: string;
    cargoTemperatureConfig?: CargoTemperatureConfig;
    filteredCargoTemperatureConfigs: CargoTemperatureConfig[];
    setFilteredCargoTemperatureConfigs: React.Dispatch<React.SetStateAction<CargoTemperatureConfig[]>>;
};

const CargoInputFieldsComponent: React.FC<Props> = ({
    keyName,
    cargoTemperatureConfig,
    filteredCargoTemperatureConfigs,
    setFilteredCargoTemperatureConfigs,
}) => {
    const { cargoTemperatureInputFields, setCargoTemperatureInputFields } = useCargoTempLogStore();
    const { checkIsCargoTempLogReadOnly } = useReadOnlyUtils();

    const isReadOnly = checkIsCargoTempLogReadOnly();

    const getIsInputFieldSelected = (config: CargoTemperatureConfig, inputField: CargoTemperatureInputField) =>
        config.inputFields.find((c) => c.cargoTemperatureInputFieldId === inputField.cargoTemperatureInputFieldId);

    const onIsInputFieldSelectedChange = (changeObject: InputChangeData) => {
        const isSelected = changeObject.event.target.checked;
        changeObject.dataObject.isSelected = isSelected;
        filteredCargoTemperatureConfigs.forEach((c) => {
            if (c.cargoTemperatureConfigId !== 0) return;
            const _inputField = c.inputFields.find((f) => f.cargoTemperatureInputFieldId === changeObject.dataObject.cargoTemperatureInputFieldId);
            if (isSelected && !_inputField) {
                c.inputFields.push({ ...changeObject.dataObject });
            } else if (!isSelected && _inputField) {
                c.inputFields = [...c.inputFields].filter(
                    (f) => f.cargoTemperatureInputFieldId !== changeObject.dataObject.cargoTemperatureInputFieldId
                );
            }
        });

        setCargoTemperatureInputFields([...cargoTemperatureInputFields]);
        setFilteredCargoTemperatureConfigs([...filteredCargoTemperatureConfigs]);
    };

    const onIsConfigInputFieldSelectedChange = (changeObject: InputChangeData) => {
        const isSelected = changeObject.event.target.checked;
        const cargoTemperatureConfig = changeObject.dataObject.cargoTemperatureConfig as CargoTemperatureConfig;
        const inputField = changeObject.dataObject.inputField as CargoTemperatureInputField;

        let cargoTempertureInputField = cargoTemperatureConfig.inputFields.find(
            (f) => f.cargoTemperatureInputFieldId === inputField.cargoTemperatureInputFieldId
        );
        if (isSelected && !cargoTempertureInputField) {
            cargoTempertureInputField = {
                cargoTemperatureInputFieldId: inputField.cargoTemperatureInputFieldId,
                fieldName: inputField.fieldName,
                isManditory: inputField.isManditory,
                isSelected: isSelected,
            };
            cargoTemperatureConfig.inputFields.push(cargoTempertureInputField);
        } else if (!isSelected && cargoTempertureInputField) {
            cargoTemperatureConfig.inputFields = cargoTemperatureConfig.inputFields.filter(
                (f) => f.cargoTemperatureInputFieldId !== cargoTempertureInputField?.cargoTemperatureInputFieldId
            );
        }
        setFilteredCargoTemperatureConfigs([...filteredCargoTemperatureConfigs]);
    };

    return (
        <>
            <Wrapper>
                {!cargoTemperatureConfig && (
                    <InputFieldsRow>
                        <h4>{!cargoTemperatureConfig ? 'Input' : ''}</h4>
                    </InputFieldsRow>
                )}
                <InputFieldsWrapper>
                    {cargoTemperatureInputFields
                        .filter((x) => x.fieldName !== 'Comment')
                        .map((inputField, i) => (
                            <InputFieldsRow key={`${keyName}_${inputField.fieldName}_${i}`}>
                                <div>{inputField.fieldName}</div>
                                <OdfjellInputComponent
                                    isReadOnly={isReadOnly}
                                    type={'checkbox'}
                                    dataObject={cargoTemperatureConfig ? { cargoTemperatureConfig, inputField } : inputField}
                                    value={
                                        cargoTemperatureConfig ? getIsInputFieldSelected(cargoTemperatureConfig, inputField) : inputField.isSelected
                                    }
                                    onChange={cargoTemperatureConfig ? onIsConfigInputFieldSelectedChange : onIsInputFieldSelectedChange}
                                />
                            </InputFieldsRow>
                        ))}
                </InputFieldsWrapper>
            </Wrapper>
        </>
    );
};

export default CargoInputFieldsComponent;
